import axios from 'axios';

const base = 'tickets-calidad';

function getTickets(query = null) {
    return axios.get(base, { params: query });
}

function getDashboard(query = null) {
    return axios.get(`${base}/dashboard`, { params: query });
}

const TicketsCalidadService = {
    getTickets,
    getDashboard,
};

export default TicketsCalidadService;
